import NavBar from "./navBar";

type LayoutProps = {
    children: React.ReactNode;
};

const Layout = ({ children }: LayoutProps) => {
    return (
        <div className="flex">
            <NavBar />
            {/* min-w-0 이 없으면 내용이 넓을 때 이 칸이 같이 넓어져 화면 전체가 가로 스크롤된다 */}
            <div className="flex-1 min-w-0">{children}</div>
        </div>
    );
};

export default Layout;
